import SuggestionPanelComponent, { SUGGESTION_PANEL_BASE_HTML_CLASS } from "./suggestion_panel_component";

// SentPanel — the confirmation. The draft is already cleared; the panel stays open on the
// thank-you so the submitter sees it landed. "Send another" reopens a fresh contribution
// form (keeping the same focus); Close dismisses.
export class SentPanel extends SuggestionPanelComponent {
  static get config() {
    return {
      componentTypeKey: "SuggestionSentPanel",
      baseHtmlClass: SUGGESTION_PANEL_BASE_HTML_CLASS,
      selector: ".suggestion_panel__panel--sent",
      phase: "sent",

      againSelector: ".suggestion_panel__again",
    };
  }

  constructor(id_or_element, host) {
    super(id_or_element, host, SentPanel.config);

    const again = this.element.querySelector(SentPanel.config.againSelector);
    if (again) again.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.dispatchAction("openWithFocus", this.readStateMachineValue("focus"));
    });
  }

  render() {
    return this.renderPanelVisibility();
  }
}
